<template>
	<div :class="['fluid yq_container pc_con',{hasBorder:!state.hasTipsBorder}]" @dragenter="dragConEnter($event)" @drop="onDragConDrop($event)" @dragleave="onDragConLeave($event)" @dragover="dragConover($event)">

		<!--myHeader></myHeader-->
		<div class="pos_con">
			<div class="inner" v-if="isMultiColumn">
				<template v-for="(i,index) in getDataCur.posCom">
					<mConet :itemMdata="i" :posCom="'posCom'" :key="index" v-on:recomponent="recomponent" @isFuncur="isFuncur" :index="index" @isfontFocus="isfontFocus"></mConet>
				</template>
			</div>
		</div>
		<div :class="['conect_inner',{'warning':isConLeave}]" style="min-height: 500px; border: 1px solid #fff;">
			<div class="con_innd">
				<vue-context-menu :contextMenuData="contextMenuData" @setAllModule="setAllModule()" @addMaterial="addMaterial()" @managementGlobalModule="managementGlobalModule()" @customModule="customModule()" @copyItem="copyItem()">
				</vue-context-menu>
				<template v-for="(i,tIndex) in getDataCur.stream">
					<!--通栏排版-->
					<div :id="i.allId" @contextmenu="showMenu(i)" :data-index="tIndex" :style="i.zinStyle" v-if="i.tName=='columnLayout'" @mouseover="hoverConect(i)" @mouseenter="enterConect(i)" @mouseleave="leaveConect(i)" :class="['columnLayout',{'enter':i.isStreamColumn}]">
						<div :style="i.layoutOuterStyle" @dragover="onStreamOver($event,i)" @dragenter="onStreamEnter($event,i)" @drop.stop='inStreamDrop($event,i)' @dragleave="onStreamLeave($event,i)" :class="['columnLayoutInner',{'enter':i.isStreamColumn}]">
							<div :class="['multi_edit f_hv',{hover:i.isHover}]">
								<span @click="isFuncur(i,{rTitle:'通栏排版',isEdit:true})">设置{{i.tText}}</span>
								<span class="icon delete" @click="delModule(i)"><i>删除模块</i></span>
							</div>
							<div :id="tIndex" v-dragresize="getDataFree" v-if="i.isShow" :style="{height:i.conStyle.height,minHeight:i.conStyle.minHeight,position:i.conStyle.position,margin:i.conStyle.margin}" class="layout_inner resizeMe">
								<div class="activ_con"><span @click="setUpDown(i,-1)" v-show="tIndex>0" class="up_icon"></span><span @click="setUpDown(i,1)" v-show="tIndex<getDataCur.stream.length-1" class="down_icon"></span></div>
								<mConet v-for="(irt,index) in i.itemInner" :class="[{outmodule:irt.fullScreen}]" :key="index" v-if="irt.isShow" :itemMdata="irt" :itemInner="i.itemInner" v-on:removeComponent="removeComponent" @isFuncur="isFuncur"></mConet>
								<div class="v_con">
									<p class="af_w">高度：{{i.conStyle.height}}</p>
								</div>
							</div>
						</div>
					</div>
					<!--标签展示-->
					<div @contextmenu="showMenu(i)" v-if="i.tName=='labelContainer'&&i.isShow" @mouseover="hoverConect(i)" @mouseenter="enterConect(i)" @mouseleave.self="leaveConect(i)" :class="['columnLayout tabContainer']" :style="i.zinStyle" :id="'labelContainerId'+tIndex">
						<div class="in_inner labelContainer" :style="[i.ulStyle,{visibility:i.isShow?'visible':'hidden'}]">
							<div class="activ_con"><span @click="setUpDown(i,-1)" v-show="tIndex>0" class="up_icon"></span><span @click="setUpDown(i,1)" v-show="tIndex<getDataCur.stream.length-1" class="down_icon"></span></div>
							<div :class="['multi_edit f_hv',{hover:i.isHover}]">
								<span @click="isFuncur(i,{rTitle:'设置标签展示',editDialHeight:'590px', isEdit:true})">设置{{i.tText}}</span>
								<span class="icon delete" @click="delModule(i)"><i>删除模块</i></span>
							</div>
							<div class="g-cf tit_con" :class="[{labelListOne:i.diretionM==1,labelListTwo:i.diretionM==2,righterdUl:i.setulStyle==3&&i.diretionM==2}]" :style="i.layoutOuterStyle">
								<div class="g-cf titlbl" :style="i.marginStyle">
									<ul :class="['g-cf',{centerUl:i.setulStyle==1&&i.diretionM==1,leftUl:i.setulStyle==2&&i.diretionM==1,rightUl:i.setulStyle==3&&i.diretionM==1}]">
										<li v-for="(ite,index) in i.labelTitle" :class="[{'labelList':ite.labelTitle,'cur':ite.cur,'no_data':!ite.labelTitle}]" :style="[i.labelTitleStyle,{borderRadius:i.labelTitleStyle.borderRadius+'px',lineHeight:i.labelTitleStyle.height}]" @click="setLabelItem(i,ite)" @mouseover="setHoverItem(i,ite)">
											<p class="title" :style="{borderRadius:i.labelTitleStyle.borderRadius+'px'}">{{ite.labelTitle}}</p>
										</li>
									</ul>
								</div>
								<div class="lbl_con">
									<div v-for="(it,index) in i.labelTitle" class="conStyle" :style="it.conStyle" v-show="i.isShow&&it.curItem == i.curItem" @dragover="onStreamOver($event,i,it)" @dragenter="onStreamEnter($event,i,it)" @drop.stop="inStreamDrop($event,i,it)" @dragleave="onStreamLeave($event,i,it)" style="min-height: 100px;">
										<template v-if="ilbl.isShow" v-for="(ilbl,dex) in it.itemInner">
											<mConet v-if="it.curItem == i.curItem" :key="dex" :itemMdata="ilbl" :itemInner="it.itemInner" v-on:removeComponent="removeComponent" @isFuncur="isFuncur"></mConet>
										</template>
									</div>
								</div>
							</div>
						</div>
					</div>
					<!--自由容器-->
					<div :id="i.allId" :data-index="tIndex" v-if="i.tName=='freeContainer'&&i.isShow" @mouseenter="enterConect(i)" @mouseover="hoverConect(i)" @mouseleave.self="leaveConect(i)" @dragover="onStreamOver($event,i)" @dragenter="onStreamEnter($event,i)" @drop.stop='inStreamDrop($event,i)' @dragleave="onStreamLeave($event,i)" :class="['in_inner freeContainer',{'enter':i.isStreamColumn}]" :style="[i.zinStyle,i.conStyle]">
						<div class="activ_con"><span @click="setUpDown(i,-1)" v-show="tIndex>0" class="up_icon"></span><span @click="setUpDown(i,1)" v-show="tIndex<getDataCur.stream.length-1" class="down_icon"></span></div>
						<div :class="['multi_edit f_hv',{hover:i.isHover}]">
							<span @click="isFuncur(i,{rTitle:'设置自由容器',isEdit:true})">设置{{i.tText}}</span>
							<span class="icon delete" @click="delModule(i)"><i>删除模块</i></span>
						</div>
						<div @contextmenu="showMenu(i)" v-dragresize="getDataFree" :id="tIndex" class="resizeMe" :style="[i.conStyle,{visibility:i.isShow?'visible':'hidden'}]">
							<mConet v-for="(ite,index) in i.itemInner" :key="index" :itemInner="i.itemInner" :itemMdata="ite" v-on:removeComponent="removeComponent" @isFuncur="isFuncur" v-if="ite.isShow"></mConet>
							<div class="v_con">
								<p class="af_w">高度：{{i.conStyle.height}}</p>
							</div>
						</div>
					</div>
					<!--多列展示-->
					<div :id="i.allId" @contextmenu="showMenu(i)" :data-index="tIndex" v-if="i.tName=='multiColumnContainer'&&i.isShow" @mouseenter="enterConect(i)" @mouseover="hoverConect(i)" @mouseleave.self="leaveConect(i)" :class="['in_inner multi_con g-cf', {'enter':i.isStreamColumn}]" :style="i.zinStyle">
						<div class="activ_con"><span @click="setUpDown(i,-1)" v-show="tIndex>0" class="up_icon"></span><span @click="setUpDown(i,1)" v-show="tIndex<getDataCur.stream.length-1" class="down_icon"></span></div>
						<div :class="['multi_edit f_hv','multi',{hover:i.isHover}]">
							<span @click="isFuncur(i,{rTitle:'设置多列排版',isEdit:true})">设置{{i.tText}}</span>
							<span class="icon delete" @click="delModule(i)"><i>删除模块</i></span>
						</div>
						<div :id="tIndex" v-dragresize="getDataFree" :style="[i.conStyle,{visibility:i.isShow?'visible':'hidden'}]">
							<div v-for="(it,index) in i.labelTitle" :style="[{height:i.conStyle.height,width:it.styleCon.width}]" :class="['clm',{'enter':i.isStreamColumn},'clm'+index]" v-if="it.isShow" @dragover="onStreamOver($event,i,it)" @dragenter="onStreamEnter($event,i,it)" @drop.stop="inStreamDrop($event,i,it)" @dragleave="onStreamLeave($event,i,it)">
								<div class="clm_inner" :style="i.conStyle">
									<div class="area_conn" :style="{padding:it.styleCon.padding}">
										<template v-for="(imy,inde) in it.itemInner">
											<mConet v-if="imy.isShow" class="outmodule" :itemMdata="imy" :key="inde" :itemInner="it.itemInner" v-on:removeComponent="removeComponent" @isFuncur="isFuncur"></mConet>
										</template>
									</div>
								</div>
							</div>
						</div>
					</div>
					<!--滑屏容器-->
					<div @contextmenu="showMenu(i)" :data-index="tIndex" v-if="i.tName=='swiperContainer'&&i.isShow" @mouseenter="enterConect(i)" @mouseover="hoverConect(i)" @mouseleave.self="leaveConect(i)" :class="['swiperContainer in_inner g-cf', {'enter':i.isStreamColumn}]" :style="i.zinStyle">
						<!--div class="activ_con"><span @click="setUpDown(i,-1)" v-show="tIndex>0" class="up_icon"></span><span @click="setUpDown(i,1)" v-show="tIndex<getDataCur.stream.length-1" class="down_icon"></span></div-->
						<div :class="['multi_edit f_hv',{hover:i.isHover}]">
							<span @click="isFuncur(i,{rTitle:'设置滑屏容器',isEdit:true})">设置{{i.tText}}</span>
							<span class="icon delete" @click="delModule(i)"><i>删除模块</i></span>
						</div>
						<div :id="i.allId" class="swiper-container">
							<div class="swiper-wrapper">
								<div class="swiper-slide" v-for="(it,index) in i.labelTitle" v-show="it.isShow" :class="['clm',{'enter':i.isStreamColumn},'clm'+index]" :style="it.layoutOuterStyle">
									<div v-if="it.curObj&&it.curObj.item==1" @dragover="onStreamOver($event,i,it)" @dragenter="onStreamEnter($event,i,it)" @drop.stop="inStreamDrop($event,i,it)" @dragleave="onStreamLeave($event,i,it)" class="area_conn sw" :style="it.zinStyle">
										<div class="et_ct">{{it.labelTitle}}</div>
										<template v-for="(imy,inde) in it.itemInner">
											<mConet v-if="imy.isShow" :itemMdata="imy" :key="inde" :itemInner="it.itemInner" v-on:removeComponent="removeComponent" @isFuncur="isFuncur"></mConet>
										</template>
									</div>
									<div v-if="it.curObj&&it.curObj.item==2" class="area_conn" :style="it.zinStyle">
										<div class="et_ct">{{it.labelTitle}}</div>
										<template v-for="(imy,inder) in it.columnTitle1">
											<div class="ar_conn" :style="{width:imy.styleCon.width}" :class="['clm_pic',{'enter':it.isStreamColumn},'clm_pic'+inder]" v-if="imy.isShow" @dragover="onStreamOver($event,i,imy,it)" @dragenter="onStreamEnter($event,i,imy,it)" @drop.stop="inStreamDrop($event,i,imy,it)" @dragleave="onStreamLeave($event,i,imy,it)">
												<div class="a_conn" :style="{padding:imy.styleCon.padding}">
													<template v-for="(inh,ind) in imy.itemInner">
														<mConet v-if="inh.isShow" class="outmodule" :itemMdata="inh" :key="ind" :itemInner="imy.itemInner" v-on:removeComponent="removeComponent" @isFuncur="isFuncur"></mConet>
													</template>
												</div>
											</div>
										</template>
									</div>
								</div>
							</div>
						</div>
						<!-- 如果需要分页器 -->
						<div class="swiper-pagination"></div>
						<!-- 如果需要导航按钮 -->
						<!--div class="swiper-button-prev"></div>
						<div class="swiper-button-next"></div-->
						<!-- 如果需要滚动条 -->
						<div class="swiper-scrollbar"></div>
					</div>
					<!--滑屏容器-->
				</template>
				<!--添加新容器-->
				<div :class="{'enter':isAddNew}" @dragenter="onAddNewEnter($event)" @drop.stop='inAddNewDrop($event)' @dragover='inAddNewOver($event)' class="g-cf addMern">
					<div class="dragNew" @click="sideConNone()">
						<p></p>
						<span>可以拖模块进来</span>
					</div>
				</div>
			</div>
		</div>
		<uiDialog v-if="editDial.isEdit" v-on:recoent="recoent" :itemMdata="itemMdata" :editDial='editDial'></uiDialog>
		<div class="artD hove_con">
			<template v-for="(i,index) in getDataCur.artD">
				<!--弹窗容器-->
				<div :id="i.allId" @contextmenu="showMenu(i)" v-if="i.isShow" class="popUpsLayout">
					<div @click="closeArtD(i)" class="art_m_bg"></div>
					<div class="art_m_outer" :style="i.zinStyle">
						<div :class="['edit_con hover',{hover:i.isHover}]">
							<span @click="isFuncur(i,{rTitle:'弹窗容器',isEdit:true})">设置{{i.tText}}</span>
							<span class="icon delete" @click="delItemArtD(i)"><i>删除模块</i></span>
						</div>
						<div class="art_m_inner" @drop.stop='inArtDrop($event,index)' :style="i.layoutOuterStyle">
							<div class="move_art header" :style="i.headStyle">
								<span class="tit" v-if="i.isHead">{{i.mTxt}}</span>
								<img @click="closeArtD(i)" class="close_icon" :src="i.mImage1.url||'https://diy.xiaohucloud.com/static/image/img/close_icon.png'" />
							</div>
							<div :style="i.conStyle">
								<mConet v-for="(irt,iex) in i.itemInner" :class="[{outmodule:irt.fullScreen}]" :key="iex" v-if="irt.isShow" :itemMdata="irt" :itemInner="i.itemInner" v-on:recomponent="recomponent" @isFuncur="isFuncur"></mConet>
							</div>
						</div>
					</div>
				</div>
			</template>
		</div>
	</div>
</template>

<script>
	import Vue from 'vue'
	import { mapState, mapMutations, mapGetters, mapActions } from 'vuex'
	import mConet from './mConet.vue'
	import uiDialog from './m/uiDialog.vue'
	import bus from '@/common/bus.js';
	import api from '@/api/$ajax.js';
	var vue = new Vue();
	export default {
		name: 'xIndex',
		components: {
			mConet,
			uiDialog
		},
		beforeCreate() {

		},
		created() {

			let ts = this;
			let param = ts.$route.params;
			let rTime;
			let stream = ts.getDataCur.stream;
			let posCom = ts.getDataCur.posCom;
			let objAll = {
				id: ts.param.id,
				type: ts.param.type,
				token: ts.param.token,
				column_id: ts.param.version_id + "000",
				version_id: ts.param.version_id
			}
      bus.$on('sideIsFuncur',(data,editDial)=>{
         var ts=this;
         ts.isFuncur(data,editDial)
      });
			bus.$on('createArtD', (data) => {
				var ts = this;
				if(data.mClass == "Typesetting") {
					let item = JSON.parse(JSON.stringify(data));
					ts.pushItemArtD(item);
				}
			});
			bus.$on('artpops', (data) => {
				var ts = this;
				console.log("daartpops" + data);
				var artD = ts.getDataCur.artD;

				artD.forEach(function(v, i) {
					if(v.allId == data) {
						v.isShow = true;
						setTimeout(function() {
							online.mounted($("#" + v.allId + " .art_m_outer"), "move_art");
							ts.$utils.autoCenter($('.art_m_outer')[0]);
							window.onresize = function() {
								ts.$utils.autoCenter($('.art_m_outer')[0]);
							};
						}, 300);
					}
				});

			});
			/*素材库的使用功能*/
			bus.$on('onMaterial', (id, data) => {
				var ts = this;
				var item = {};
				ts.materialId = id;
				var stream = ts.getDataCur.stream;
				var zIndexLen = stream.length;
				item = JSON.parse(data);
				item.zinStyle.zIndex = zIndexLen;
				if(stream.length > 1) {
					stream.forEach(function(v, i) {
						if(i == 0) {
							v.isShowUp = false;
							v.isShowDown = true;
						} else {
							v.isShowUp = true;
							v.isShowDown = true;
						}
					});
					item.isShowUp = true;
					item.isShowDown = false;
				}

				item.allId = 'm' + ts.$utils.GenNonDuplicateID();
				var item = JSON.parse(JSON.stringify(item));
				for(let i = 0; item.itemInner.length > i; i++) {
					item.itemInner[i].allId = "m" + ts.$utils.GenNonDuplicateID();
				}
				ts.pushItemStream(item);
				setTimeout(function() {
					var h = $(document).height() - $(window).height();
					$(document).scrollTop(h);
				}, 600);
			});


			ts.setDelayed(param.param);

			if(ts.param.param.endsWith(ts.param.version_id + "000")) {
				ts.getAllLocalData(ts.param);
			} else {
				ts.getData(ts.param);
				ts.getAllSite(objAll);
			}

			if(stream && stream.length) {
				for(let j = 0; j < stream.length; j++) {
					stream[j].isHover = false;
					stream[j].isStopPropagation = false;
				}
			}

			stream.forEach(function(v, i) {
				if(i == 0) {
					v.isShowUp = false;
					v.isShowDown = true;
				} else if(i == stream.length - 1) {
					v.isShowUp = true;
					v.isShowDown = false;
				} else {
					v.isShowUp = true;
					v.isShowDown = true;
				}
			});

			function unScroll() {
				var top = $(document).scrollTop();
				$(document).on('scroll.unable', function(e) {
					$(document).scrollTop(top);
				})
			}

			function removeUnScroll() {
				$(document).unbind("scroll.unable");
			}

			function run(event) {
				var itCur = {};
				event.preventDefault();
				if(ts.fontFocus) {
					return;
				}
				for(var v in ts.getDataCur) {
					var dataCur = ts.getDataCur[v];
					for(let j = 0; j < dataCur.length; j++) {
						var arSpon = dataCur[j];
						if(arSpon.mClass == 'Typesetting') {
							var itemInner = arSpon.itemInner;
							var labelTitle = arSpon.labelTitle;
							if(itemInner) {
								for(let k = 0; k < itemInner.length; k++) {
									if(itemInner[k].parentStyle.active) {
										itCur = itemInner[k];
									}
								}
							} else if(labelTitle) {
								for(let k = 0; k < labelTitle.length; k++) {
									if(labelTitle[k].itemInner) {
										var dtin = labelTitle[k].itemInner;
										for(let k = 0; k < dtin.length; k++) {
											if(dtin[k].parentStyle.active) {
												itCur = dtin[k];
											}
										}
									}
								}
							}
						} else {
							if(arSpon.parentStyle.active) {
								itCur = arSpon;
							}
						}
					}
				}

				if(JSON.stringify(itCur) === '{}') {
					return;
				}

				if(event.keyCode == 37) { //Left
					itCur.isShow = false;
					itCur.parentStyle.left -= 2;
					setTimeout(function() {
						itCur.isShow = true;
					}, 1);
				} else if(event.keyCode == 38) { //up
					itCur.isShow = false;
					itCur.parentStyle.top -= 2;
					setTimeout(function() {
						itCur.isShow = true;
					}, 1);
				} else if(event.keyCode == 39) { //right
					itCur.isShow = false;
					itCur.parentStyle.left += 2;
					setTimeout(function() {
						itCur.isShow = true;
					}, 1);
				} else if(event.keyCode == 40) { //down
					itCur.isShow = false;
					itCur.parentStyle.top += 2;
					setTimeout(function() {
						itCur.isShow = true;
					}, 1);
				}
			}

			/*
			 *keycode 37 = Left ←
			 *keycode 38 = Up ↑
			 *keycode 39 = Right →
			 *keycode 40 = Down ↓
			 * */

			$("body").bind('keyup', function(event) {
				run(event);
			}).bind("keydown", function() {
				clearTimeout(rTime);
				unScroll();
			}).bind("click", function() {
				removeUnScroll();
				clearTimeout(rTime);
			});

		},
		data() {
			return {
				isMultiColumn: true,
				isConLeave: false,
				id: this.$route.params.id,
				fontFocus: false,
				curIndex: 0,
				param: {
					id: this.$route.params.id,
					param: this.$route.params.param,
					manage: this.$route.query.manage,
					company_id: this.$route.query.company_id,
					token: this.$route.query.token,
					column_id: this.$route.query.column_id,
					type: this.$route.query.type,
					version_id: this.$route.query.pc_version_id
				},
				itemMdata: {},
				isLine: {
					isShow: false,
					lineStyle: {
						height: "",
						width: "",
						top: "",
						left: ""
					}
				},
				editDial: {
					isEdit: false,
					rTitle: "设置自由容器",
				},
				contextMenuData: {
					menuName: this.$utils.guid(),
					axios: {
						x: null,
						y: null
					},
					menulists: [{
							fnHandler: 'setAllModule',
							btnName: '设置为全局模块'
						}, {
							fnHandler: 'customModule',
							btnName: '设置为自定义模块'
						},
						{
							fnHandler: 'copyItem',
							btnName: '复制模块'
						}
					]
				},
				isAddNew: false
			}
		},
		methods: {
			enterStyle(i, ite, index, e) {
				e.target.style.color = i.labelTitleStyleHover.color;
				e.target.style.background = i.labelTitleStyleHover.background;
				e.target.style.borderColor = i.labelTitleStyleHover.borderColor;
			},
			funcEmition(item) {
				bus.$emit('onSetAmit', item);
			},
			leaveStyle(i, ite, index, e) {
				if(ite.cur == false) {
					e.target.style.color = i.labelTitleStyle.color;
					e.target.style.background = i.labelTitleStyle.background;
					e.target.style.borderColor = i.labelTitleStyle.borderColor;
				}
			},
			addTitle(i) {
				var newlabelTitle = {
					labelTitle: "标签" + (i.labelTitle.length + 1),
					curItem: i.labelTitle.length,
					cur: false,
					is_show: 1,
					conStyle: {
						paddingTop: '0',
						paddingLeft: '0',
						paddingRight: '0',
						paddingBottom: '0',
						borderWidth: '0',
						height: "220px"
					},
					lblClass: "long_i1",
					itemInner: []
				}
				i.labelTitle.push(newlabelTitle);
			},
			closeArtD(item) {
				let ts = this;
				item.isShow = false;
				//ts.saveloca(ts.param);
			},
			deleteLabel(oEvent, i, list, index) {
				oEvent.stopPropagation();
				var ind = i.labelTitle.indexOf(list);
				i.labelTitle.splice(ind, 1);
			},
			showMenu(item) {
				let ts = this;
				ts.transferIndex = item;
				event.preventDefault();
				let allSite = JSON.parse(localStorage.getItem(ts.param.version_id + "000")) || [];
				let faAll = false;
				if(!Array.isArray(allSite) && allSite.itemCon) {
					allSite = allSite.itemCon[ts.param.version_id + "000"].stream;
				}

				if(!!item.allId) {
					for(let i = 0; allSite.length > i; i++) {
						if(allSite[i].allId == item.allId) {
							faAll = true;
						}
					}
				}

				if(faAll) {
					ts.contextMenuData.menulists[0].btnName = "管理全局模块";
					ts.contextMenuData.menulists[0].fnHandler = "managementGlobalModule";
				} else {
					ts.contextMenuData.menulists[0].btnName = "设置为全局模块";
					ts.contextMenuData.menulists[0].fnHandler = "setAllModule";
				}
				//debugger

				if(ts.param.manage == 1) {
					ts.contextMenuData.menulists[0].btnName = "加入素材库";
					ts.contextMenuData.menulists[0].fnHandler = "addMaterial";
				}
				let x = event.clientX;
				let y = event.clientY;
				ts.contextMenuData.axios = {
					x,
					y
				}
			},
			addMaterial(e) {
				let ts = this;
				// debugger
				//console.log(ts.getDataCur.stream.indexOf(ts.transferIndex));
				let material = localStorage.getItem('material') || '{}';

				if(material !== '{}') {
					material = JSON.parse(material);
					if(ts.materialId != -1) {
						material.id = ts.materialId;
					}
					material.config = JSON.stringify(ts.transferIndex);
					material.type = ts.param.type;
					material.url = ts.param.domain_url;
					api.post('/api/effect/save', true, material, r => {
						if(r.code == 422) {
							// console.log(r.message);
							return;
						}
						vue.$msg('保存成功!');
					});
				}

				//debugger;
			},
			customModule(e) {
				let ts = this;
				bus.$emit('onCustomModule', ts.transferIndex);
			},
			managementGlobalModule() {
				let ts = this;
				var url = '/pc/t1/' + ts.$route.params.id + "/" + ts.$route.query.pc_version_id + '000?token=' + ts.$route.query.token + '&company_id=' + ts.$route.query.company_id + '&type=' + ts.$route.query.type + '&mobile_version_id=' + ts.$route.query.mobile_version_id + '&pc_version_id=' + ts.$route.query.pc_version_id + '&domain_url=' + ts.$route.query.domain_url + '&lang=' + ts.$route.query.lang;
				window.open(window.location.origin + url);
			},
			setAllModule(e) {
				let ts = this;
				var obj = {
					id: ts.param.id,
					guid: ts.$utils.guid(),
					version_id: ts.param.version_id,
					type: ts.param.type,
					order: ts.transferIndex
				};
				ts.setItemSite(obj);
				ts.orderbyId();
			},
			copyItem(e) {
				let ts = this;
				let obj = {
					index: ts.getDataCur.stream.indexOf(ts.transferIndex),
					order: JSON.parse(JSON.stringify(ts.transferIndex))
				};
				obj.order.allId = "m" + ts.$utils.GenNonDuplicateID();
				if(obj.order.tName == "columnLayout" || obj.order.tName == "freeContainer") {
					for(let i = 0; obj.order.itemInner.length > i; i++) {
						obj.order.itemInner[i].allId = "m" + ts.$utils.GenNonDuplicateID();
					}
				} else if(obj.order.tName == "labelContainer") {
					for(let j = 0; obj.order.labelTitle.length > j; j++) {
						let itemInner = obj.order.labelTitle[j].itemInner;
						for(let i = 0; itemInner.length > i; i++) {
							itemInner[i].allId = "m" + ts.$utils.GenNonDuplicateID();
						}
					}
				}
				ts.copyModule(obj);
				ts.orderbyId();
			},
			sideConNone() {
				this.state.flag = "onItem0";
			},
			isFuncur(i, item) {
				let ts = this;
				i.isEdit = true;
				ts.editDial = item;
				ts.itemMdata = i;
			},
			setLabelItem(i, item) {
				if(i.labelStyle == 2) {
					for(let k = 0; i.labelTitle.length > k; k++) {
						i.labelTitle[k].cur = false;
					}
					item.cur = true;
					i.curItem = item.curItem;
				}
			},
			getDataFree(v) {
				let ts = this;
				ts.getDataCur.stream[v.el].draging = true;
				ts.getDataCur.stream[v.el].conStyle.height = v.height;
			},
			isfontFocus(flag, index) {
				let ts = this;
				var it = ts.getDataCur.stream[index];
				if(!it) {
					return;
				}
				if(Number(flag) == 1) {
					it.isStopPropagation = true;
					it.isHover = false;
				} else if(Number(flag) == 2) {
					it.isStopPropagation = false;
					//this.getDataCur.stream[index].isHover = false;
				} else if(Number(flag) == 3) {
					ts.fontFocus = index;
				}
			},
			enterConect(it) {
				if(it.isStopPropagation) {
					it.isHover = false;
					return;
				}
				it.isHover = true;
				var zin = JSON.parse(JSON.stringify(it.zinStyle));
				it.curIndex = zin.zIndex;
				it.zinStyle.zIndex = 100;
			},
			hoverConect(it) {
				if(it.isStopPropagation) {
					it.isHover = false;
					return;
				}
				it.isHover = true;
			},
			leaveConect(it) {
				it.isHover = false;
				it.isStopPropagation = false;
				it.zinStyle.zIndex = it.curIndex;
			},
			recoent(itemMdata) {
				//this.itemEditCur(null);
			},
			onDragConLeave(event) {
				this.isConLeave = true;
				//console.log("离开外层标准流容器");
			},
			dragConEnter(event) {
				//console.log("进入外层标准流容器");
			},
			onDragConDrop(event) {
				let ts = this;
				ts.isConLeave = false;
				event.preventDefault();
				if(!ts.state.curOrder) return;
				if(ts.state.curOrder.mClass == "Typesetting") {
					return;
				}
				let obj = ts.state.curOrder;
				let itemCon = ts.getDataCur.posCom;
				if(itemCon) {
					for(var i = 0; itemCon.length > i; i++) {
						itemCon[i].cur = false;
					}
				}
				obj.parent = false;
				obj.parentStyle.top = 200;
				obj.parentStyle.left = 5;
				let item = JSON.parse(JSON.stringify(obj));
				item.cur = true;
				item.allId = "m" + ts.$utils.GenNonDuplicateID();
				ts.pushItemPosCom(item);
			},
			inArtDrop(e, i) {
				let ts = this;
				e.preventDefault();
				if(!ts.state.curOrder) return;
				if(ts.state.curOrder.mClass == "Typesetting") {
					return;
				}
				let obj = ts.state.curOrder;
				obj.parent = false;
				obj.parentStyle.top = 200;
				obj.parentStyle.left = 5;
				let item = JSON.parse(JSON.stringify(obj));
				item.cur = true;
				item.allId = "m" + ts.$utils.GenNonDuplicateID();
				ts.pushItemArtCom({
					i,
					item
				});
			},
			dragConover(event, i) {
				event.preventDefault();
				this.isConLeave = false;
				//console.log("进入外层标准流容器(移动阶段 )");
			},
			onStreamEnter(event, i) {
				//console.log("进入标准流容器");
				/*$(".multi_con").each(function(v) {
					var h = $(this).height();
					$(this).find(".clm").height(h);
				});*/
				event.preventDefault();
			},
			onStreamOver(event, i) {
				i.isStreamColumn = true;
				//console.log("进入标准流容器(移动阶段 )");
			},
			onStreamLeave(event, i) {
				i.isStreamColumn = false;
				//console.log("离开标准流容器标准流容器");
			},
			inStreamDrop(event, i, it, iy) {
				let ts = this;
				//console.log("拖入" + i.tText);
				event.preventDefault();
				i.isStreamColumn = false;

				if(!ts.state.curOrder) return;
				if(JSON.stringify(ts.state.curOrder) === '{}') return;
				var obj = ts.state.curOrder;
				var itemCon = [];
				var stream = ts.getDataCur.stream;
				if(i.conStyle && ts.state.curOrder.parentStyle && ts.state.curOrder.parentStyle.height > i.conStyle.height) {
					i.conStyle.height = (ts.state.curOrder.parentStyle.height + 20) + "px";
				}
				var item = JSON.parse(JSON.stringify(obj));
				item.allId = "m" + ts.$utils.GenNonDuplicateID();
				item.order = itemCon.length + 1;

				if(obj.mClass == "Typesetting") {
					if(item.tName == "swiperContainer") {
						$("body").addClass("swiperHover");
					}

					if(item.tName == "columnLayout" || item.tName == "freeContainer") {
						for(let i = 0; item.itemInner.length > i; i++) {
							item.itemInner[i].allId = "m" + ts.$utils.GenNonDuplicateID();
						}
					} else if(item.tName == "labelContainer") {
						for(let j = 0; item.labelTitle.length > j; j++) {
							let itemInner = item.labelTitle[j].itemInner;
							for(let i = 0; itemInner.length > i; i++) {
								itemInner[i].allId = "m" + ts.$utils.GenNonDuplicateID();
							}
						}
					}

					if(i.tName == "columnLayout" && obj.tName == "freeContainer") { //通栏
						i.layoutOuterStyle.width = "1200px";
						i.conStyle.position = 'relative';
						return;
					} else if(i.tName == "swiperContainer" && obj.tName == "freeContainer") {
						if(it.index) {
							iy.zinStyle.width = "1200px";
							iy.curObj.item = 1;
							return;
						}
						it.zinStyle.width = "1200px";
						it.curObj.item = 1;
						return;
					} else if(i.tName == "swiperContainer" && obj.tName == "multiColumnContainer") {
						it.zinStyle.width = "100%";
						it.curObj.item = 2;
						return;
					}

					var obj = {
						index: ts.getDataCur.stream.indexOf(i) + 1,
						order: item
					}

					ts.copyModule(obj);
					stream.forEach(function(v, i) {
						if(i == 0) {
							v.isShowUp = false;
							v.isShowDown = true;
						} else if(i == stream.length - 1) {
							v.isShowUp = true;
							v.isShowDown = false;
						} else {
							v.isShowUp = true;
							v.isShowDown = true;
						}
					});

					// debugger
					ts.setCurOrder(null);
					return;
				}

				if(i.tName == "labelContainer" || i.tName == "multiColumnContainer" || i.tName == "swiperContainer") { //标签展示//多列容器//滑屏容器
					//i.ulStyle.width = "1200px";

					var flag = true;
					for(let k = 0; i.labelTitle.length >= k; k++) {
						it.itemInner.push(item);
						ts.setCurOrder(null);
						return;
					}
					//debugger
				}

				if(item.tName == "moduleAreaNav") { //栏目导航
					i.zinStyle.zIndex = 900;
				}
				// item.allId = ts.$utils.GenNonDuplicateID();
				item.column = it || -1;
				//debugger
				ts.pushItemStreamItem({
					i,
					item
				});
			},
			setHoverItem(i, item) {
				if(i.labelStyle == 1) {
					for(let k = 0; i.labelTitle.length > k; k++) {
						i.labelTitle[k].cur = false;
					}
					item.cur = true;
					i.curItem = item.curItem;
				}
			},
			onAddNewEnter(event) {
				//console.log("进入新增容器(进入阶段 )");
				event.preventDefault();
			},
			inAddNewDrop(event) {
				//console.log("拖入新增容器");
				event.preventDefault();
				var ts = this;
				if(!ts.state.curOrder) return;
				var item = {};
				var stream = ts.getDataCur.stream;
				var zIndexLen = stream.length;
				if(ts.state.curOrder.mClass != "Typesetting") {
					var imHeight = 100;
					if(ts.state.curOrder.parentStyle && ts.state.curOrder.parentStyle.height >= 100) {
						imHeight = ts.state.curOrder.parentStyle.height + 20;
					}

					if(ts.state.curOrder.tName == "moduleAreaNav") { //栏目导航
						zIndexLen = 900;
					}
					item = {
						tName: "freeContainer",
						tText: "自由容器",
						isEdit: false,
						mClass: "Typesetting",
						isStreamColumn: false,
						isShowUp: false,
						isShow: true,
						order: stream.length,
						isShowDown: false,
						isHover: false,
						isStopPropagation: false,
						mImage: {
							url: "",
						},
						zinStyle: {
							zIndex: zIndexLen
						},
						conStyle: {
							width: '1200px',
							margin: "0 auto",
							height: imHeight + 'px'
						},
						order: 1,
						itemInner: [],
						aloneIcon: "panelModuleIcon_pack moduleArea_pack",
						aloneText: "moduleAloneText",
						cur: true
					}
					ts.state.curOrder.allId = "m" + ts.$utils.GenNonDuplicateID();
					item.itemInner.push(ts.state.curOrder);

					/*if(ts.state.curOrder.tName == 'mImage') {
						ts.isFuncur(ts.state.curOrder, {
							editDialWidth: "950px",
							editDialHeight: "680px",
							setlink: false,
							isEdit: true,
							rTitle: '编辑图片<span style="font-size:12px; color:#666;"> (&nbsp;只能添加jpg,jpeg,gif,png, 免费版大小不超过1MB&nbsp;)</span>'
						});
					}*/

				} else {
					item = ts.state.curOrder;
					ts.state.curOrder.order = zIndexLen;
					item.zinStyle.zIndex = zIndexLen;
				}

				if(stream.length > 1) {
					stream.forEach(function(v, i) {
						if(i == 0) {
							v.isShowUp = false;
							v.isShowDown = true;
						} else {
							v.isShowUp = true;
							v.isShowDown = true;
						}
					});
					item.isShowUp = true;
					item.isShowDown = false;
				}
				item.allId = "m" + ts.$utils.GenNonDuplicateID();
				if(item.tName == "columnLayout" || item.tName == "freeContainer") {
					item.conStyle.width = "1200px";
					for(let i = 0; item.itemInner.length > i; i++) {
						item.itemInner[i].allId = "m" + ts.$utils.GenNonDuplicateID();
					}
				} else if(item.tName == "labelContainer") {
					item.ulStyle.width = "1200px";
					for(let j = 0; item.labelTitle.length > j; j++) {
						let itemInner = item.labelTitle[j].itemInner;
						for(let i = 0; itemInner.length > i; i++) {
							itemInner[i].allId = "m" + ts.$utils.GenNonDuplicateID();
						}
					}
				} else if(item.tName == "swiperContainer") {
					console.log("swiperContainer");
					$("body").addClass("swiperHover");
				}

				var item = JSON.parse(JSON.stringify(item));
				ts.pushItemStream(item);
			},
			removeComponent(comp) {
				let ts = this;

				ts.delItemStream(comp);
				ts.orderbyId();

			},
			recomponent(comp) {
				let ts = this;
				ts.delItemPos(comp);
				ts.orderbyId();
				ts.isMultiColumn = false;
				setTimeout(function() {
					ts.isMultiColumn = true;
				}, 1);
				//ts.saveloca(ts.param);
			},
			delItemArtD(comp) {
				let ts = this;
				ts.delItemArtD(comp);
				ts.orderbyId();
				//ts.saveloca(ts.param);
			},
			setUpDown(i, flag) {
				let ts = this;
				var stream = ts.getDataCur.stream;
				var k = stream.indexOf(i);
				var obj = {
					k: k,
					j: k + flag
				}
				ts.change(obj);
				stream.forEach(function(v, i) {
					if(i == 0) {
						v.isShowUp = false;
						v.isShowDown = true;
					} else if(i == stream.length - 1) {
						v.isShowUp = true;
						v.isShowDown = false;
					} else {
						v.isShowUp = true;
						v.isShowDown = true;
					}
				});
				ts.orderbyId();
				//ts.saveloca(ts.param);
			},
			delModule(item) {
				let ts = this;
				let obj = {
					id: ts.param.id,
					type: ts.param.type,
					order: item
				}
				ts.delStreamModule(obj);
				if(item.tName == "swiperContainer") {
					//console.log("swiperContainer");
					$("body").removeClass("swiperHover");
				}
				ts.orderbyId();
				//ts.saveloca(ts.param);
			},
			inAddNewOver(event) {
				event.preventDefault();
				//console.log("进入新增容器(移动阶段 )");
			},
			...mapActions([
				"getData", "saveloca"
			]),
			...mapMutations([
				'orderbyId', 'setDelayed', 'getAllLocalData', 'delItemPos', "delItemArtD", 'copyModule', 'delStreamModule', 'setCurOrder', 'setItemSite', "getAllSite", 'pushItemStream', "pushItemPosCom", "pushItemArtD", "pushItemArtCom", "pushItemStreamItem", "delItemStream", "change"
			])
		},
		mounted() {
			let ts = this;

			setTimeout(function() {

				for(let v in ts.getDataCur.stream) {
					var dataCur = ts.getDataCur.stream[v];
					if(dataCur.tName == "labelContainer") {
						hoverAction.labelHover("#labelContainerId" + v, dataCur);
					} else if(dataCur.tName == "swiperContainer") {
						$("body").addClass("swiperHover");
						//hoverAction.swiperHover(dataCur.allId, dataCur);
					}
				}

				for(let i in ts.getDataCur.artD) {
					var o = ts.getDataCur.artD[i];
					if(o.tName == "popUpsLayout") {
						hoverAction.popUpsInit(o.allId, o);
						online.mounted($("#" + o.allId + " .art_m_outer"), "move_art");
					}
				}
			}, 500);

			ts.$utils.autoCenter($('.art_m_outer')[0]);
			window.onresize = function() {
				ts.$utils.autoCenter($('.art_m_outer')[0]);
			};
			setTimeout(function() {
				urlLink.initLoad(ts.param.company_id);
			}, 400)

		},
		updated() {
			let ts = this;

			for(var v in ts.getDataCur.stream) {
				var dataCur = ts.getDataCur.stream[v];
				if(dataCur.tName == "labelContainer") {
					setTimeout(function() {
						hoverAction.labelHover("#labelContainerId" + v, dataCur);
					}, 400)

				}
			}
		},
		computed: {
			...mapGetters(["state", "getDataCur", "router"])
		}
	}
</script>

<style lang="scss" scoped>
	.line_cx {
		position: absolute;
		left: 450px;
		top: 300px;
		z-index: 99999999;
		background-color: red;
		width: 300px;
		height: 1px;
	}

	.columnLayout,
	.freeContainer,
	.swipercontainer .columnLayout .layout_inner {
		border: 1px dashed transparent;
		background-repeat: no-repeat;
		background-position: top center;
	}

	.freeContainer,
	.multi_con {
		margin: 0 auto;
	}

	.yq_container .conect_inner {
		background-color: #fff;
		position: relative;
		z-index: 3;
		margin: 0 auto;
		.columnLayout {
			position: relative;
			.v_con {
				position: absolute;
				display: none;
				background: #fff;
				bottom: -27px;
				border: 1px dashed #444;
			}
			.v_con.block {
				display: block;
			}
		}
	}

	.in_outer {
		position: relative;
	}

	.pos_con {
		/*position: absolute;
		top: 0;
		z-index: 55;*/
		.inner {
			margin: 0 auto;
		}
	}

	.yq_container .warning {
		border: 1px dashed red;
	}

	.lbl_con {
		border: 1px dashed #fff;
	}

	.lbl_con:hover {
		border-color: #0D83ED;
	}

	.swiper-slide {
		min-height: 150px;
	}

	.in_inner {
		.resizeMe {
			position: relative;
		}
		.v_con {
			position: absolute;
			background: #fff;
			display: none;
			bottom: -27px;
			border: 1px dashed #444;
		}
		.v_con.block {
			display: block;
		}
		.del_icon {
			text-align: left;
		}
		.multi_edit {
			position: absolute;
			top: -40px;
			right: 0;
			width: auto;
			height: 40px;
			z-index: 5;
			line-height: 40px;
			display: none;
			background: #FFFFFF;
			border-radius: 5px;
			box-shadow: 0 2px 4px 3px rgba(0, 0, 0, 0.15);
			padding: 0 15px;
			span {
				float: left;
				cursor: pointer;
				margin-right: 10px;
				margin-left: 5px;
			}
			span:nth-child(1) {
				line-height: 25px;
				border-right: 1px solid #E3E3E3;
				margin-top: 7px;
				padding-right: 8px;
				margin-left: 10px;
			}
			.icon {
				background: url(../../../static/image/bg03.png)no-repeat;
			}
			.icon i {
				position: absolute;
				display: block;
				font-size: 12px;
				width: auto;
				line-height: 25px;
				padding: 0px 10px;
				background: #FFFFFF;
				border-radius: 5px;
				box-shadow: 0 1px 4px 2px rgba(0, 0, 0, 0.1);
				top: -23px;
				margin-left: -25px;
				display: none;
			}
			.style {
				display: block;
				background-position: -64px -186px;
				width: 21px;
				height: 21px;
				margin-top: 10px;
			}
			.style:hover {
				background-position: -64px -232px;
			}
			.style:hover i {
				display: block;
			}
			.animation {
				display: block;
				background-position: -372px -186px;
				width: 21px;
				height: 20px;
				margin-top: 10px;
			}
			.animation:hover {
				background-position: -372px -232px;
			}
			.animation:hover i {
				display: block;
			}
			.borderhid {
				display: block;
				background-position: -275px -186px;
				width: 21px;
				height: 20px;
				margin-top: 10px;
			}
			.borderhid:hover {
				background-position: -275px -232px;
			}
			.borderhid:hover i {
				display: block;
			}
			.delete {
				display: block;
				background-position: -108px -186px;
				width: 21px;
				height: 20px;
				margin-top: 10px;
			}
			.delete:hover {
				background-position: -108px -232px;
			}
			.delete:hover i {
				display: block;
			}
		}
	}

	.multi_con {
		position: relative;
	}

	.tabContainer.columnLayout {
		border: none;
	}

	.columnLayout,
	.swipercontainer {
		.layout_inner {
			border: 1px dashed transparent;
		}
		.layout_inner:hover {
			border: 1px dashed #0D83ED;
		}
		.multi_edit {
			position: absolute;
			top: -40px;
			right: 0;
			width: auto;
			height: 40px;
			z-index: 77;
			line-height: 40px;
			display: none;
			background: #FFFFFF;
			border-radius: 5px;
			box-shadow: 0 2px 4px 3px rgba(0, 0, 0, 0.15);
			padding: 0 15px;
			span {
				float: left;
				cursor: pointer;
				margin-right: 10px;
				margin-left: 5px;
			}
			span:nth-child(1) {
				line-height: 25px;
				border-right: 1px solid #E3E3E3;
				margin-top: 7px;
				padding-right: 8px;
				margin-left: 10px;
			}
			.icon {
				background: url(../../../static/image/bg03.png) no-repeat;
			}
			.icon i {
				position: absolute;
				display: block;
				font-size: 12px;
				width: auto;
				line-height: 25px;
				padding: 0px 10px;
				background: #FFFFFF;
				border-radius: 5px;
				box-shadow: 0 1px 4px 2px rgba(0, 0, 0, 0.1);
				top: -23px;
				margin-left: -25px;
				display: none;
			}
			.style {
				display: block;
				background-position: -64px -186px;
				width: 21px;
				height: 21px;
				margin-top: 10px;
			}
			.style:hover {
				background-position: -64px -232px;
			}
			.style:hover i {
				display: block;
			}
			.animation {
				display: block;
				background-position: -372px -186px;
				width: 21px;
				height: 20px;
				margin-top: 10px;
			}
			.animation:hover {
				background-position: -372px -232px;
			}
			.animation:hover i {
				display: block;
			}
			.borderhid {
				display: block;
				background-position: -275px -186px;
				width: 21px;
				height: 20px;
				margin-top: 10px;
			}
			.borderhid:hover {
				background-position: -275px -232px;
			}
			.borderhid:hover i {
				display: block;
			}
			.delete {
				display: block;
				background-position: -108px -186px;
				width: 21px;
				height: 20px;
				margin-top: 10px;
			}
			.delete:hover {
				background-position: -108px -232px;
			}
			.delete:hover i {
				display: block;
			}
		}
		.multi_edit:hover {
			display: block;
		}
	}

	.clm,
	.area_conn {
		border: 1px dashed transparent;
	}

	.in_inner:hover,
	.columnLayout:hover,
	.swipercontainer:hover {
		border-color: #0D83ED;
		.clm,
		.area_conn {
			border: 1px dashed #0D83ED !important;
		}
		.ar_conn {
			border: 1px dashed #0D83ED !important;
		}
		/*.multi_edit {
			display: block;
		}*/
	}

	.in_inner,
	.columnLayout,
	.swipercontainer {
		position: relative;
		.multi_edit.hover {
			display: block;
		}
	}

	.multi_con {
		.clm {
			border: 1px dashed #fff;
			float: left;
			.area_conn {
				min-height: 100px;
			}
			.dragNew {
				position: absolute;
				bottom: 8px;
				width: 100%;
			}
		}
	}

	.longitud {
		.tit_con {
			float: left;
			width: 20%;
		}
		.long_con {
			float: left;
			width: 80%;
		}
	}

	.labelContainer,
	.freeContainer {
		position: relative;
	}

	.labelList {
		position: relative;
		cursor: pointer;
		i {
			position: absolute;
			top: 0px;
			right: 5px;
			width: 25px;
			height: 25px;
			background: url(/static/image/iconIndex2.png) -1028px 218px;
			display: none;
		}
	}

	.labelList:hover i {
		display: block;
	}

	.yq_container {
		.enter {
			border: #5874d8 1px dashed;
		}
	}

	.dragNew {
		min-height: 70px;
		padding-top: 20px;
		padding-bottom: 10px;
		text-align: center;
		border: 1px dashed #CCC;
		p {
			text-align: center;
			cursor: pointer;
			width: 205px;
			margin: 0 auto;
			height: 51px;
			background: url(../../../static/image/iconIndex2.png) no-repeat;
			background-position: -400px -503px;
			margin-bottom: 5px;
		}
	}

	.dragNew:hover {
		border: 1px dashed #0D83ED;
	}

	.dragNew:hover p {
		background-position: -153px -503px;
	}

	.columnLayoutInner {
		position: relative;
		margin: 0 auto;
	}

	.in_inner:hover .activ_con,
	.columnLayout:hover .activ_con,
	.swipercontainer:hover .activ_con {
		display: block;
	}

	.activ_con {
		display: none;
		position: absolute;
		right: 0;
		top: 0;
		z-index: 40;
		width: 30px;
		.down_icon {
			height: 30px;
			cursor: pointer;
			display: block;
			width: 30px;
			background: url(../../../static/image/down_icon.png) no-repeat 0 0;
		}
		.up_icon {
			height: 30px;
			display: block;
			cursor: pointer;
			width: 30px;
			background: url(../../../static/image/up_icon.png) no-repeat 0 0;
		}
	}

	.swiperContainer {
		.multi_edit {
			top: 0;
		}
	}

	.swiperContainer {
		top: 85px !important;
	}

	.addMern {
		width: 990px;
		margin: 0 auto;
	}
</style>



// WEBPACK FOOTER //
// src/components/t1/index.vue